export default __webpack_public_path__ + "static/island-life-mobile-199905d73fc918ec39317cc41c7d0a32.webp";